"use strict";

exports.__esModule = true;
exports.PopoverButton = exports.DataItemValueElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Utils = require("../../../Utils");
var _Device = require("../../Device");
var _MeasurementValueWithTimestamp = require("../../Measures/MeasurementValue/MeasurementValueWithTimestamp");
var _Time = require("../../Time");
var _common = require("../common");
var _DataItemPopover = require("../common/DataItemPopover/DataItemPopover");
var _Feature = _interopRequireDefault(require("../../FeatureFlags/Feature/Feature"));
var _featureFlags = require("../../../featureFlags");
var _Env = require("../../Env");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _dec, _dec2, _dec3, _class;
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var findDataItem = function findDataItem(device, dataItemName) {
  return (0, _Device.getDeviceDataItems)(device).find(function (item) {
    return item.name === dataItemName;
  });
};

/**
 * Displays a particular MTC data item value for a device.
 */

var PopoverButton = exports.PopoverButton = _styledComponents["default"].div.withConfig({
  displayName: "DataItemValueElement__PopoverButton",
  componentId: "sc-1cwme3o-0"
})(["position:absolute;top:", "px;right:", "px;z-index:2;"], function (props) {
  return props.top || 0;
}, function (props) {
  return props.right || 0;
});
var DataItemValueElement = exports.DataItemValueElement = (_dec = _Device.DeviceContext.withContext, _dec2 = _Time.TimeContext.withContext, _dec3 = _Env.EnvContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = /*#__PURE__*/function (_Component) {
  function DataItemValueElement() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      mouseOverWidget: false,
      dataItem: findDataItem(_this.props.device, _this.props.dataItemName)
    };
    _this.handleMouseEnter = function () {
      _this.setState({
        mouseEnterWidget: true
      });
    };
    _this.handleMouseLeave = function () {
      _this.setState({
        mouseEnterWidget: false
      });
    };
    _this.renderSubscription = function (dataItem) {
      var _this$props = _this.props,
        device = _this$props.device,
        hideLabel = _this$props.hideLabel,
        hideTimestamp = _this$props.hideTimestamp,
        time = _this$props.time,
        hideMtcAgentUnits = _this$props.hideMtcAgentUnits,
        timestampType = _this$props.timestampType,
        decimalPlaces = _this$props.decimalPlaces,
        env = _this$props.env,
        path = _this$props.path,
        updateLayout = _this$props.updateLayout;
      return /*#__PURE__*/_react["default"].createElement("div", {
        onMouseEnter: _this.handleMouseEnter,
        onMouseLeave: function onMouseLeave() {
          _this.handleMouseLeave();
        },
        "data-testid": "DataItemValueElement.widget"
      }, /*#__PURE__*/_react["default"].createElement(_Feature["default"], {
        name: _featureFlags.ENABLE_DATA_ITEM_EDIT,
        negative: false
      }, /*#__PURE__*/_react["default"].createElement(PopoverButton, {
        top: 0,
        right: 0
      }, /*#__PURE__*/_react["default"].createElement(_DataItemPopover.DataItemPopover, {
        dataItems: [dataItem == null ? void 0 : dataItem.name],
        onSubmit: function onSubmit(values) {
          if (env.featureFlags.includes(_featureFlags.ENABLE_DATA_ITEM_SAVE)) {
            updateLayout(path, "dataItemName", values[0]);
          }
          _this.setState({
            dataItem: findDataItem(device, values[0])
          });
        },
        showButton: _this.state.mouseEnterWidget,
        device: device
      }))), /*#__PURE__*/_react["default"].createElement(_Device.DeviceDataItemSubscription, {
        deviceUuid: device.uuid,
        dataItem: dataItem
      }, function (packet) {
        return /*#__PURE__*/_react["default"].createElement(_Device.DeviceColorController, _extends({
          deviceUuid: device.uuid
        }, (0, _common.getWidgetColorProps)(_this.props), {
          value: packet && packet.value || ""
        }), function (_ref) {
          var color = _ref.color,
            backgroundColor = _ref.backgroundColor;
          var timestamp = timestampType === "receivedAt" ? packet == null ? void 0 : packet.receivedAt : packet == null ? void 0 : packet.timestamp;
          var value = packet && packet.value;
          if (typeof value === "number" && !Number.isInteger(packet.value) && decimalPlaces) {
            value = new Number(packet.value).toFixed(decimalPlaces);
          }
          return /*#__PURE__*/_react["default"].createElement(_MeasurementValueWithTimestamp.MeasurementValueWithTimestamp, _extends({
            color: color,
            backgroundColor: backgroundColor
          }, (0, _common.getWidgetPositionProps)(_this.props), (0, _common.getWidgetFontProps)(_this.props), (0, _common.getWidgetInteractionProps)(_this.props), {
            value: value,
            timestamp: !hideTimestamp && packet ? timestamp : null,
            timezone: time && time.timezone && time.timezone.name,
            units: dataItem.units || "",
            label: !hideLabel && (0, _Utils.humanizeString)(dataItem.name || ""),
            hideMtcAgentUnits: hideMtcAgentUnits
          }));
        });
      }));
    };
    return _this;
  }
  _inheritsLoose(DataItemValueElement, _Component);
  var _proto = DataItemValueElement.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        dataItem: findDataItem(this.props.device, this.props.dataItemName)
      });
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      device = _this$props2.device,
      backgroundColorSource = _this$props2.backgroundColorSource;
    if (!this.state.dataItem) {
      if (backgroundColorSource) {
        return /*#__PURE__*/_react["default"].createElement(_Device.DeviceColorController, _extends({
          deviceUuid: device.uuid
        }, (0, _common.getWidgetColorProps)(this.props)), function (colors) {
          return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, (0, _common.getWidgetPositionProps)(_this2.props), (0, _common.getWidgetInteractionProps)(_this2.props)), colors.backgroundColor && /*#__PURE__*/_react["default"].createElement("rect", {
            x: 0,
            y: 0,
            width: _this2.props.width,
            height: _this2.props.height,
            fill: colors.backgroundColor
          }));
        });
      }
      return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, (0, _common.getWidgetPositionProps)(this.props), (0, _common.getWidgetInteractionProps)(this.props)));
    }
    if (backgroundColorSource) {
      return this.renderSubscription(this.state.dataItem);
    }
    return this.renderSubscription(this.state.dataItem);
  };
  return DataItemValueElement;
}(_react.Component)) || _class) || _class) || _class);